import { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigContext } from '@client/hoc/config/ConfigContext';
import { getHeaderCampaigns } from '@client/redux/modules/headerCampaigns/selectors';
import { fetchHeaderCampaigns } from '@client/redux/modules/headerCampaigns/actions';

export const useCampaigns = () => {
    const dispatch = useDispatch();
    const { config } = useContext(ConfigContext);
    const campaigns = useSelector(getHeaderCampaigns);

    useEffect(() => {
        if (!campaigns || !campaigns.length) {
            dispatch(fetchHeaderCampaigns());
        }
    }, []);

    return campaigns.map(campaign => ({
        ...campaign,
        imageUrl: campaign.imageUrl
            ? `${config.getUrl('campaign')}${campaign.imageUrl}`
            : undefined
    }));
};
